import { Stack } from "expo-router";
import React from "react";

export default function MyPlacesLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" options={{ title: "My Places" }} />
      <Stack.Screen name="[id]" options={{ title: "Edit Place" }} />
      <Stack.Screen name="new" options={{ title: "New Place" }} />
    </Stack>
  );
}
